import { styled } from '@material-ui/core/styles';

export const Img = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
});
